import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import axiosInstance from '../../../Config/axiosInstance';
import './DetailsSummaryOffer.css';
import BusinessIcon from '@mui/icons-material/Business';
import PublishSharpIcon from '@mui/icons-material/PublishSharp';
import { Button } from '@mui/material';

function DetailsSummaryOffer() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState(null);

  const formatNumber = (value, locale = 'ro-RO') => {
    if (value === null || value === undefined || value === '') return '';

    const n = Number(value);
    if (Number.isNaN(n)) return '';

    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  };

  useEffect(() => {
    const fetchOfferDetails = async () => {
      try {
        const response = await axiosInstance.get(`/summary-offer-details/${id}/`);
        setFormData(response.data);
      } catch (err) {
        console.error('Failed to load offer details', err);
      }
    };

    fetchOfferDetails();
  }, [id]);

  const getTotalSystem = () => {
    const total = formData?.total_cost_offer_without_vat_system || 0;
    const currency = formData?.system_currency || '';

    return `${formatNumber(total)} ${currency}`.trim();
  };

  const getBudgetCurrentValue = (budget) => {
    if (budget.cost_po_without_vat !== null && budget.cost_po_without_vat !== undefined && Number(budget.cost_po_without_vat) !== 0) {
      return budget.cost_po_without_vat;
    }

    return budget.cost_offer_without_vat;
  };

  const getBudgetSystemValue = (budget) => {
    if (
      budget.cost_po_without_vat_system !== null &&
      budget.cost_po_without_vat_system !== undefined &&
      Number(budget.cost_po_without_vat_system) !== 0
    ) {
      return budget.cost_po_without_vat_system;
    }

    return budget.cost_offer_without_vat_system;
  };

  const renderBudgets = (sourceTypes) => {
    const rows =
      formData?.cost_element?.flatMap(costEl =>
        costEl.project_budgets
          .filter(budget => sourceTypes.includes(budget.source_type))
          .map((budget, index) => {
            const currentValue = getBudgetCurrentValue(budget);
            const systemValue = getBudgetSystemValue(budget);

            return (
              <tr key={`${costEl.id}-${index}`}>
                <td>{costEl.cost_element_description}</td>
                <td>{budget.source_type}</td>
                <td>
                  {formatNumber(currentValue)} {budget.currency}
                </td>
                <td>
                  {formatNumber(systemValue)} {budget.system_currency || formData?.system_currency || ''}
                </td>
              </tr>
            );
          })
      ) || [];

    if (rows.length === 0) {
      return (
        <tr>
          <td colSpan="4">
            <span className="no-data-message">
              No data available for this section.
            </span>
          </td>
        </tr>
      );
    }

    return rows;
  };

  return (
    <div className="summary-offer-details-page">
      <div className="summary-offer-details-container">
        <div className="header">
          <ArrowBackIcon className="back-arrow" onClick={() => navigate(-1)} />
          <h2 className="add-supplier-title">Back</h2>
        </div>
      </div>

      <hr className="title-separator" />

      <div className="summary-container">
        <div className="summary-card summary-card-left">
          <div className="summary-title">
            <ReceiptLongRoundedIcon />
            <h3>Summary Project</h3>
          </div>

          <div className="details-info">
            <div className="offer-code">{formData?.offer_code || '-'}</div>
            {formData?.status === 'Emisa' && (
              <span className="status-badge">🟢 {formData.status}</span>
            )}
          </div>
        </div>

        <div className="summary-card summary-card-center">
          <div className="contract-no">
            Contract no. : #{formData?.contract_number || '----'}
          </div>
          <div className="project-code">
            Project code : {formData?.project_code || '----'}
          </div>
        </div>

        <div className="summary-card summary-card-right">
          <Button className="primavera-export-button">
            <PublishSharpIcon />P6 Export
          </Button>
        </div>
      </div>

      <div className="client-title">
        <BusinessIcon />
        {formData?.client || '----'}

        <div className="total-box">
          Total: {getTotalSystem()}
        </div>
      </div>

      <div className="budgets-section">
        <table className="budgets-table">
          <thead>
            <tr style={{ backgroundColor: '#29D74F', color: 'white' }}>
              <th>PM</th>
              <th>Source</th>
              <th>Cost offer</th>
              <th>Cost offer System</th>
            </tr>
          </thead>
          <tbody>
            {renderBudgets(["Internal", "External"])}
          </tbody>
        </table>
      </div>

      <div className="budgets-section">
        <table className="budgets-table">
          <thead>
            <tr style={{ backgroundColor: '#ffe641', color: 'rgb(53, 53, 53)' }}>
              <th>Administrative</th>
              <th>Source</th>
              <th>Cost offer</th>
              <th>Cost offer System</th>
            </tr>
          </thead>
          <tbody>
            {renderBudgets(["Additional Internal"])}
          </tbody>
        </table>
      </div>

      <div className="budgets-section">
        <table className="budgets-table">
          <thead>
            <tr style={{ backgroundColor: '#ef4d2f', color: 'white' }}>
              <th>Procurement Materials</th>
              <th>Source</th>
              <th>Cost offer</th>
              <th>Cost offer System</th>
            </tr>
          </thead>
          <tbody>
            {renderBudgets(["Material"])}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DetailsSummaryOffer;